import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Card from 'components/Layout/Card'
import PageHeader from 'components/Layout/PageHeader'
import api from 'api'
import { AppContext } from 'contexts/AppContext'
import { canManageDispositions, clientInvoicesAgencyId } from 'constant/authorization'
import { ReactRouterParams } from 'types/various'
import AgencyTabs from '../AgencyTabs'
import DispositionsList from './DispositionsList'
import './AgencyDispositions.scss'

const AgencyDispositions: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams<ReactRouterParams>()
  const { userData, allowedFor } = useContext(AppContext)
  const [agencyName, setAgencyName] = useState<string>('')
  // Clients get a read-only list of the invoices of their own agency, without the agency tabs
  const isClientView =
    Boolean(clientInvoicesAgencyId(userData.user)) && !canManageDispositions(allowedFor)

  useEffect(() => {
    if (!id || isClientView) {
      return
    }

    api.agency
      .getAgency(id)
      .then(res => setAgencyName(res.data.node.name))
      .catch(() => void {})
  }, [id, isClientView])

  if (!id) {
    return null
  }

  return (
    <>
      <PageHeader>
        {isClientView ? (
          t('agencies.invoices.title')
        ) : (
          <>
            {t('agencies.form.editAgency')}
            {agencyName && `: ${agencyName}`}
          </>
        )}
      </PageHeader>

      {!isClientView && <AgencyTabs agencyId={id} />}

      <Card className='AgencyDispositions'>
        <DispositionsList
          agencyId={id}
          readOnly={isClientView}
        />
      </Card>
    </>
  )
}

export default AgencyDispositions
